export default __webpack_public_path__ + "static/media/02_affrescati_hero_375x700.34fb5997.mp4";